export enum UserTier {
  SILVER = 'Silver',
  GOLD = 'Gold',
  AUTHORIZED = 'Authorized',
  PLATINUM = 'Platinum',
}
